// SPD (Sensitive Personal Data) RSAA lifecycle action types.
// CHECK = presence flags (both CCIDs, one call); GET = show-data values (per CCID);
// SAVE = persist on apply. No edit-time / seed action.
export const CHECK_CUSTOMER_SPD_REQUEST = '[CustomerCard] Check Customer SPD Request';
export const CHECK_CUSTOMER_SPD_SUCCESS = '[CustomerCard] Check Customer SPD Success';
export const CHECK_CUSTOMER_SPD_FAILURE = '[CustomerCard] Check Customer SPD Failure';

export const GET_CUSTOMER_SPD_REQUEST = '[CustomerCard] Get Customer SPD Request';
export const GET_CUSTOMER_SPD_SUCCESS = '[CustomerCard] Get Customer SPD Success';
export const GET_CUSTOMER_SPD_FAILURE = '[CustomerCard] Get Customer SPD Failure';

export const SAVE_CUSTOMER_SPD_REQUEST = '[CustomerCard] Save Customer SPD Request';
export const SAVE_CUSTOMER_SPD_SUCCESS = '[CustomerCard] Save Customer SPD Success';
export const SAVE_CUSTOMER_SPD_FAILURE = '[CustomerCard] Save Customer SPD Failure';

export const RESET_CUSTOMER_SPD_LOAD_STATE = '[CustomerCard] Reset Customer SPD Load State';
